import React, { Component } from 'react';
import axios from 'axios';
const Axios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  const loginToken = localStorage.getItem('loginToken');
  Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;

class Post extends Component {
  constructor(props) {
    super(props);
    const { steps } = this.props;
    const { submit, firstname, lastname, email } = steps;

    this.state =  
             { 
                 submit, 
                 firstname, 
                 lastname, 
                 email,
                 userdetail:[] 
            }; 
  }


  componentDidMount() {
    const userObject = {
      submit:this.state.submit.value,
      first_name:this.state.firstname.value,
      last_name:this.state.lastname.value,
      email:this.state.email.value,
      //step_id:this.state.step_id.value
    };
    Axios.post(`${process.env.REACT_APP_API_URL}master/chatbox`, userObject)
    .then(res => {
        this.setState({userdetail:res.data});
      console.log(res.status)
    }).catch(function(error) {
      console.log(error);
    });
  }

  render() {
    return (
        <div>
      <div>Thank you! Your data was submitted successfully!</div>
      <table>
          <tr>
              <td>First Name</td>
              <td>{this.state.userdetail.first_name}</td>
          </tr>
          <tr>
              <td>Last Name</td>
              <td>{this.state.userdetail.last_name}</td>
          </tr>
          <tr>
              <td>Email ID</td>
              <td>{this.state.userdetail.email}</td>
          </tr>          
      </table>
      </div>
      );
    }
  };


  export default Post;